var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:[ _vm.classes ? _vm.classes : 'btn btn-secondary'],attrs:{"to":_vm.url,"exact":""}},[_c('i',{class:[ _vm.icone ? _vm.icone : 'fa fa-reply']}),_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }